// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import './App.css'; // Import global styles

// Pages
import Home from './pages/Home';
import AboutAbhikalp from './pages/AboutAbhikalp.js';
import Services from './pages/Services';
import Support from './pages/Support';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import RefundPolicy from './pages/RefundPolicy';
import ShippingPolicy from './pages/ShippingPolicy';

function App() {
  return (
    <BrowserRouter>
      {/* GLOBAL NAVIGATION */}
      <nav className="navbar">
        <Link to="/" className="brand-link">
          {/* Ensure logo.png is in your public/images folder */}
          <img src="/images/abhikalp-logo.png" alt="Logo" style={{height: '32px'}} />
          Abhikalp
        </Link>
        <div className="nav-links">
          <Link to="/" className="nav-item">Home</Link>
          <Link to="/about" className="nav-item">About</Link>
          <Link to="/services" className="nav-item">Services</Link>
          <Link to="/support" className="nav-item">Contact</Link>
        </div>
      </nav>

      {/* PAGE CONTENT */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutAbhikalp />} />
        <Route path="/services" element={<Services />} />
        <Route path="/support" element={<Support />} />
        
        {/* Compliance Pages */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
      </Routes>

      {/* GLOBAL FOOTER */}
      <footer className="footer-container">
        <div className="footer-nav">
          <Link to="/terms" className="footer-link">Terms & Conditions</Link>
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <Link to="/refund-policy" className="footer-link">Refund Policy</Link>
          <Link to="/shipping-policy" className="footer-link">Shipping Policy</Link>
          <Link to="/support" className="footer-link">Support</Link>
        </div>
        <p className="copyright">&copy; {new Date().getFullYear()} Abhikalp (ARK Strategic Management Consultancy Services). All rights reserved.</p>
      </footer>
    </BrowserRouter>
  );
}

export default App;